import { render, staticRenderFns } from "./account-mobile-phone-popover.vue?vue&type=template&id=2a6c7bd0&"
import script from "./account-mobile-phone-popover.vue?vue&type=script&lang=js&"
export * from "./account-mobile-phone-popover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports